export default __webpack_public_path__ + "static/media/dubai-design-district.cc3bc889.png";